<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-card
      v-if="isQuoteValid"
      data-unit-test="lg-quote-card"
      :class="{ 'offer-border': hasSpecialOffer }"
      width="100%"
    >
      <quote-details
        :qd="qd"
        :has-special-offer="hasSpecialOffer"
        :site-id="quote.site_id"
      />
    </v-card>
  </div>
</template>

<script>
import QuoteDetails from './QuoteDetails';

export default {
  name: 'lg-quote',
  components: {
    QuoteDetails,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  computed: {
    qd () {
      return this.quote.details;
    },
    hasSpecialOffer () {
      return !!this.qd?.specialOffer;
    },
    isQuoteValid () {
      return !!this.qd?.imageSiteRemote;
    },
  },
};
</script>

<style scoped lang="scss" src='@/assets/scss/results/results-quote.scss' />
